export default "__VITE_ASSET__OLsSwTZh__"